<template>
    <div class="user-area-wrap">
        <div class="menu-userHidden">
            <div @click="userInfo = !userInfo" class="show-userInfo pointer">
                <i class="icon icon-dropdown" v-bind:class="userInfo ? 'down' : 'up'"></i>
            </div>
        </div>
        <loading-block v-if="loading"/>
        <transition name="fade" v-else>
            <div class="user-area" v-if="userInfo">
                <div class="row wrap-user">
                    <div class="col-4 wrap-avatar">
                        <div class="img-cover">
                            <img :src="user.avatar">
                        </div>
                    </div>
                    <div class="col-8">
                        <div class="user-greeting">Helo,</div>
                        <div class="user-name"><img v-if="user.checklist == true"  width="23" height="23" src="/assets/images/checklist.svg"> {{ user.fullname }} {{ user.lastname ? user.lastname : '' }}
                            <img v-if="user.verification ==1" class="user-name-badge" src="/assets/images/icons/check.svg">
                        </div>
                        <div class="user-bio" v-if="user.bio">Bio: {{ user.bio }}</div>
                        <div class="wrap-point" v-if="user.type =='0' || user.type==null">
                            <img class="wrap-point-icon" src="/assets/images/icons/point.svg">
                            <div class="wrap-point-text">
                                {{ user.point }} Point
                            </div>
                        </div>
                    </div>
                </div>
<!--                <div class="row user-count">-->
<!--                    <div class="col-4 text-center">-->
<!--                        &lt;!&ndash;                    Follower: <strong>15</strong>&ndash;&gt;-->
<!--                    </div>-->
<!--                    <div class="col-4 text-center">Publish <strong>{{ statistic.publish }}</strong></div>-->
<!--                    <div class="col-4 text-center">-->
<!--                        &lt;!&ndash;                    Following: <strong>35</strong>&ndash;&gt;-->
<!--                    </div>-->
<!--                </div>-->




               <div class="row user-statistic">
                    <div class="col-6 text-center mrgn">
                        <a target="_blank" href="https://chat.whatsapp.com/BaeP6rcAgv45PD1guBLzEt"><img width="200" class="user-name-badg" src="/assets/images/whatsapp.png"></a> 
                    </div>
                    <div class="col-6 text-center mrgn">
                        <a target="_blank" href="https://bit.ly/GrupYoursayCommunity"><img width="200" src="/assets/images/telegram.png"></a>
                    </div>

               </div>

             <div class="box-create">
                <div class="write-now pointer  rad-left" @click="goToWrite">
                    <span>Tulis Sekarang</span> <img class="user-name-badge btn-size pointer" src="/assets/images/icons/add.svg" @click="goToWrite">
                </div>

                 <div class="write-now pointer rad-right" @click="goToVideo">
                    <span>Buat Video</span> <img class="user-name-badge btn-size pointer" src="/assets/images/icons/add.svg" @click="goToVideo">
                </div>
             </div>   
            </div>
        </transition>
        <!-- 
        <div class="contact-info">
            <a target="_blank" href="https://chat.whatsapp.com/G4wMYow0aWT5odPbJXtjWg"><img width="50" src="/assets/images/whatsapp.png"></a>

            <a target="_blank" href="https://bit.ly/GrupYoursayCommunity"><img width="53" src="/assets/images/telegram.png"></a>
        </div> 
    -->
        <div v-if="$route.name !='profile-edit'">
            <div v-if="$route.name !='profile' && user.register_log =='arkadiame'" >
                 
                <alertprofile v-if="user.profile_new ==false" position="mobile"/>
              
            </div>
        </div>
    </div>
</template>


<script>
import axios from "axios";
import Alertprofile from "../../mobile/components/Alertprofile";
export default {
    
    data() {
        return {
            userInfo: false,
            user: {},
            article: {},
            video: {},
            loading: false,
            btndisable:''
        }
    },
    

    async mounted() {
        if(this.$route.name === 'home') {
            this.loading = true
        }

        await this.getUser()
        await this.getStatisticArticle()
        await this.getStatisticVideo()
        if(this.$route.name === 'home') {
            this.userInfo = true
            this.loading = true
        }
        this.loading = false;
    },
    components: {
        Alertprofile
    },
    methods: {
        async getUser() {
            const token = this.$cookies.get('token');
            await axios.get('/api/user', { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.user = response.data;
                    
                    if(this.user.profile_new != true) {
                       this.btndisable = 'disabled';
                    }
                })
                .catch((error) => {

                });
        },
        async getStatisticArticle() {
            const token = this.$cookies.get('token');
            await axios.get('/api/user/statistic-article', { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.article = response.data
                })
                .catch((error) => {

                });
        },
        async getStatisticVideo() {
            const token = this.$cookies.get('token');
            await axios.get('/api/user/statistic-video', { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.video = response.data
                })
                .catch((error) => {

                });
        },
        goToWrite() {
            this.$router.push({name: 'post-create'});
        },
        goToVideo(){
            this.$router.push({name: 'video-create'});
        }
    }
}
</script>

<style scoped>
.user-area-wrap {
    position: relative;
}
.btn-size{
    width: 20%!important;
}
.user-area {
    background: #EC550E;
    padding-bottom: 60px;
    padding-top: 20px;
    position: relative;
}
.wrap-user {
    align-items: center;
}
.wrap-avatar {
    display: flex;
    justify-content: flex-end;
}
.user-greeting {
    font-size: 16px;
    line-height: 24px;
    font-family: "Poppins", sans-serif;
    color: #fff;
}
.user-name {
    font-size: 18px;
    line-height: 27px;
    font-weight: 700;
    font-family: "Poppins", sans-serif;
    color: #fff;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
}
.user-name .user-name-badge {
    margin-left: 5px;
}
.user-bio {
    font-size: 12px;
    line-height: 16px;
    font-family: "Poppins", sans-serif;
    color: #fff;
}
.wrap-point {
    flex-direction: row;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 10px;
}
.wrap-point .wrap-point-icon {
    margin-right: 5px;
    width: 18px;
}
.wrap-point .wrap-point-text {
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 27px;
    color: #fff;
}
.user-count {
    color: #fff;
    font-family: "Poppins", sans-serif;
    border-top: 1px solid #fff;
    border-bottom: 1px solid #fff;
    margin-right: 5%;
    margin-left: 5%;
    padding: 5px 0;
    margin-top: 15px;
}
.user-statistic {
    color: #fff;
    margin-top: 30px;
}
.user-statistic-item {
    display: flex;
    justify-content: center;
    align-items: center;
}
.user-statistic-item img {
    margin-right: 5px;
    width: 25px;
}
.write-now {
    background: #fff;
    text-align: center;
   /* margin: 0 5% 0 5%;*/
    box-shadow: 0 4px 10px rgb(0 0 0 / 12%);
   
    padding: 15px;
    font-family: "Poppins", sans-serif;
    font-size: 12px;
    line-height: 27px;
    position: relative;
    width: 50%;
    bottom: -10%;
}

.box-create{
    float: left;
    width: 100%;
    margin-top: 16px;
    padding: 0px 10px;
}

.rad-left{
     border-radius: 10px 0px 0px 10px;
     float: left;
}

.rad-right{
     border-radius: 0px 10px 10px 0px;
     float: right;
}

.menu-userHidden {
    margin-top: -20px;
    padding: 10px;
    right: 0;
    z-index: 98;
    position: absolute;
}
.menu-userHidden .icon {
    border-radius: 50%;
    width: 16px;
    height: 16px;
}
.show-userInfo.pointer {
    background: #eb5624;
    border-radius: 50%;
    padding: 4px;
    box-shadow: 3px 3px 17px 1px rgb(161 161 161 / 39%);
    -webkit-box-shadow: 3px 3px 17px 1px rgb(161 161 161 / 39%);
    -moz-box-shadow: 3px 3px 17px 1px rgb(161 161 161 / 39%);
}
.write-now a {
    color: #333333;
}
.write-now a:hover {
    text-decoration: none;
}
a {
    text-decoration: none;
    color: #333333;
}
.img-cover {
    width: 100px;
    height: 100px;
    overflow: hidden;
    border-radius: 50%;
}
.img-cover img {
    width: 100px;
    height: 100px;
    object-fit: cover;
    border: 2px solid #fff;
    border-radius: 50%;
}

.btn-video-create{
    bottom: -102px!important;
}
.contact-info{
        float: left;
    width: 100%;
    padding: 21px 152px 0px;

}

.mrgn{
    margin: 0px 0px 15px;
}
</style>
